import { createItemsData } from '../utils/request-utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const localitiesService = new Service('/locations/localities', HALApiService, createItemsData)
